
























import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const settings = namespace('Settings');

@Component({})
export default class Home extends Vue {
  @settings.State public colorMode!: 'light' | 'dark';
}
